import { Container, Row, Col } from "react-bootstrap";

import colorSharp2 from "../assets/img/color-sharp2.png";
import "animate.css";
import TrackVisibility from "react-on-screen";
import python from "../assets/img/noteToEvents.png";

import moodleDoodle from "../assets/img/modelDoodle.png";
import { PersonalProjectCard } from "./PersonalProjectCard/PersonalProjectCard";

const PersonalProject = () => {
  const projects = [
    {
      title: "Model Doodle",
      description:
        "An AI-powered web app where you draw, and a neural network guesses what it is — then spins a short magical story around it.",
      imgUrl: moodleDoodle,
      github: "https://github.com/sajina09/DoodleVision",
      demo: "https://modeldoodle.netlify.app",
      skills: ["CNN classifier", "LLM", "TensorFlow", "HuggingFace"],
    },
    {
      title: "Note to Calendar",
      description:
        "React app that converts note-style schedules into downloadable calendar files (.ics).",
      imgUrl: python,
      github: "https://github.com/sajina09/Calendar-Events-FE",
      demo: "https://calendar-eve.netlify.app",
      skills: ["Flask API", "React", "iCalendar"],
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Personal Projects</h2>
                  <Row className="g-4">
                    {projects.map((project, index) => (
                      <Col key={index} xs={12} md={6} lg={6}>
                        <PersonalProjectCard {...project} />
                      </Col>
                    ))}
                  </Row>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" alt="idk" src={colorSharp2}></img>
    </section>
  );
};

export default PersonalProject;
